import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import styles from "../styles/AdminSettings.module.scss";
import api from "../../../utils/api";
import { Heading2 } from "../../../components/value-cssmodules/TextComponent";
import Spinner from "../../../components/Spinner";

const AdminSettings = () => {
  const [commissionForm, setCommissionForm] = useState({
    commissionRate: 0,
  });

  const intl = useIntl();
  const [commissionSuccess, setCommissionSuccess] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleCommissionSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true)
    try {
      api.put('/admin/settings', commissionForm);
    } catch (error) {
      setCommissionSuccess(false);
      console.error(error);
    } finally {
      setLoading(false)
    }
    setCommissionSuccess(true);
    setTimeout(() => setCommissionSuccess(false), 3000);
  };

  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true)
      try {
        const res = await api.get('/admin/settings')
        setCommissionForm((prev) => ({
          ...prev,
          commissionRate: res.data.commissionRate
        }))
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
    fetchSettings()
  }, [])

  if (loading) return <Spinner />

  return (
    <div className={styles.page}>
      <Heading2>
        <FormattedMessage id="admin.settings.title" defaultMessage="Settings" />
      </Heading2>

      {/* Basic Settings */}
      {/* <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Podstawowe</h2>
        <form onSubmit={handleBasicSubmit} className={styles.form}>
          <div className={styles.field}>
            <label className={styles.label}>Nazwa serwisu</label>
            <input
              className={styles.input}
              type="text"
              value={basicForm.siteName}
              onChange={(e) => setBasicForm({ ...basicForm, siteName: e.target.value })}
              placeholder="np. MyShop"
            />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Email wsparcia</label>
            <input
              className={styles.input}
              type="email"
              value={basicForm.supportEmail}
              onChange={(e) => setBasicForm({ ...basicForm, supportEmail: e.target.value })}
              placeholder="support@example.com"
            />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Telefon kontaktowy</label>
            <input
              className={styles.input}
              type="tel"
              value={basicForm.contactPhone}
              onChange={(e) => setBasicForm({ ...basicForm, contactPhone: e.target.value })}
              placeholder="+48 000 000 000"
            />
          </div>
          <div className={styles.formFooter}>
            {basicSuccess && <span className={styles.success}>✓ Zapisano</span>}
            <button type="submit" className={styles.submitButton}>
              Zapisz zmiany
            </button>
          </div>
        </form>
      </section> */}

      {/* Commission Settings */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>
          <FormattedMessage id="admin.settings.sectionCommission" defaultMessage="Commission" />
        </h2>
        <form onSubmit={handleCommissionSubmit} className={styles.form}>
          <div className={styles.field}>
            <label className={styles.label}>
              <FormattedMessage id="admin.settings.labelCommissionRate" defaultMessage="Commission rate (%)" />
            </label>
            <input
              className={styles.input}
              type="number"
              min="0"
              max="1"
              step="0.1"
              value={commissionForm.commissionRate}
              onChange={(e) => setCommissionForm({ ...commissionForm, commissionRate: Number(e.target.value) })}
              placeholder={intl.formatMessage({ id: "admin.settings.placeholderCommissionRate", defaultMessage: "e.g. 1" })}
            />
          </div>
          <div className={styles.formFooter}>
            {commissionSuccess && (
              <span className={styles.success}>
                {intl.formatMessage({ id: "admin.settings.saved", defaultMessage: "Saved" })}
              </span>
            )}
            <button type="submit" className={styles.submitButton}>
              {intl.formatMessage({ id: "admin.settings.buttonUpdateCommission", defaultMessage: "Update commission" })}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default AdminSettings;